import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";

export const useGetCustomerShoppingList = (
    queryKey: string | (string | number)[],
    customerId: string,
    options?: { enabled?: boolean; keepPreviousData?: boolean },
): UseQueryResult<types.IShoppingList | null> => {
    const auth = useAuth();

    return useQuery<types.IShoppingList | null>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch without authorization token.");
            }
            return await api.ShoppingLists.getForCustomer(customerId, auth.token);
        },
        options,
    );
};
